export default function radianToDegree(angle: number): number {
  return angle * (180 / Math.PI);
}
